import { Box } from '@chakra-ui/react';

import { useScheduleGenerateState } from 'View/schedule-generate/state';
import getProgressWidth from 'View/schedule-generate/helper/getProgressWidth';

import styles from './styles.module.css';

const Progress = () => {
  const { viewState } = useScheduleGenerateState();
  const width = getProgressWidth(viewState);
  return (
    <Box className={styles['progress__container']}>
      <Box className={styles['progress__content-value']} width={width} data-testid="progress-content-value" />
    </Box>
  );
};

export default Progress;
